module.exports = __webpack_public_path__ + "static/panda-ef86bac76d35f629d279468e96bda9a1.gif";